@if (step === 'ministry') {
  <zwi-simple-form-page>
    @if (isNativePlatform === false) {
      <zwi-headline>Ministry  information</zwi-headline>
    } @else {
      <zwi-back-headline (navigateBack)="navigateToIndex()">Ministry information</zwi-back-headline>
    }
    @if (step === 'ministry') {
      <zwi-signup-ministry [ministry]="ministryAccount.ministry" (updateMinistry)="updateMinistry($event)"></zwi-signup-ministry>
    }
  </zwi-simple-form-page>
} @else {
  <zwi-simple-form-page>
    <zwi-headline>Create a Zwiloo account</zwi-headline>
    @if (step === 'account') {
      <zwi-signup-account (changeStep)="changeStep($event)"
      (updateAccount)="updateAccount($event)"></zwi-signup-account>
    }
  </zwi-simple-form-page>
}
